import React from 'react'
import AiHero from '../Components/Automation/AiHero';
import OurServiceOffer from '../Components/Automation/OurServiceOffer';
import AccContact from '../Components/Accelerating/AccContact';
import { Helmet } from 'react-helmet-async';

// BFSI Specific Solutions (Grid Section based on user list)
const bfsiSolutions = [
    {
        id: 1,
        title: "Retail Banking",
        category: "solution",
        desc: "Transform consumer banking with hyper-personalized digital experiences, secure mobile banking, and seamless multi-channel onboarding.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/retail-banking",
    },
    {
        id: 2,
        title: "Corporate Banking",
        category: "solution",
        desc: "Streamline B2B financial operations, trade finance, and cash management with advanced enterprise-grade banking platforms.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/corporate-banking",
    },
    {
        id: 3,
        title: "Investment Banking",
        category: "solution",
        desc: "Empower capital markets with high-frequency trading platforms, algorithmic insights, and secure post-trade settlement solutions.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/investment-banking",
    },
    {
        id: 4,
        title: "FinTech Innovations",
        category: "solution",
        desc: "Build disruptive financial products, from digital wallets to blockchain integrations, designed for the modern digital economy.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/fintech-solutions",
    },
    {
        id: 5,
        title: "Insurance (Life, Health, General)",
        category: "solution",
        desc: "Automate claims processing, underwriting, and risk assessment using AI to deliver faster and more accurate insurance services.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/insurance-tech",
    },
    {
        id: 6,
        title: "Wealth Management",
        category: "solution",
        desc: "Provide intelligent robo-advisory, portfolio tracking, and tailored investment strategies to high-net-worth clients.",
        defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
        link: "/wealth-management",
    },
    {
        id: 7,
        title: "Asset Management",
        category: "solution",
        desc: "Optimize fund management operations with data-driven analytics, compliance tracking, and automated reporting systems.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#2C5364]",
        link: "/asset-management",
    },
    {
        id: 8,
        title: "Payment Systems",
        category: "solution",
        desc: "Develop secure, real-time payment gateways and cross-border transaction networks complying with global financial standards.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#0F2027]",
        link: "/payment-systems",
    },
    {
        id: 9,
        title: "Lending Platforms",
        category: "solution",
        desc: "Deploy end-to-end digital lending solutions featuring automated credit scoring, quick loan origination, and smart collections.",
        defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#203A43]",
        link: "/lending-platforms",
    },
];

function BFSIIndustryDetail() {
    return (
        <div>
            <Helmet>
    <title>
        BFSI Solutions | Banking, Financial Services & Insurance | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers digital solutions for Banking, Financial Services and Insurance, helping organizations modernize legacy systems, strengthen security, improve compliance, and create seamless financial experiences."
    />

    <meta
        name="keywords"
        content="BFSI Solutions, BFSI Technology Solutions, Banking Technology Solutions, Financial Services Solutions, Insurance Technology Solutions, BFSI Enterprise AI & ServiceNow Consulting, Banking Software Solutions, FinTech Solutions, Retail Banking Solutions, Corporate Banking Solutions, Investment Banking Solutions, Wealth Management Solutions, Asset Management Solutions, Payment Solutions, Digital Lending Solutions, Insurance Technology Services, Banking Application Development, Financial Services Technology"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/industries/bfsi"
    />

    <meta
        property="og:title"
        content="BFSI Solutions | Banking, Financial Services & Insurance | Mobikode"
    />

    <meta
        property="og:description"
        content="Transform banking, financial services and insurance operations with Mobikode's secure, scalable digital solutions across banking, FinTech, payments, lending, wealth management and insurance."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/industries/bfsi"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/item1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="BFSI Solutions | Banking, Financial Services & Insurance | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's BFSI technology solutions for retail and corporate banking, FinTech, insurance, payments, lending, wealth management and asset management."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/item1.png"
    />
</Helmet>
            {/* Hero Section Updated for BFSI */}
            <AiHero title="Banking, Financial Services & Insurance" imgData="/assets/what/item1.png" />

            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">
                        {/* Image Container */}
                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item2.png"
                                alt="BFSI Digital Transformation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        {/* Overlapping Text Box */}
                        <div className="relative z-20 w-full flex justify-center items-center lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] 
                            -mt-6 lg:mt-0 lg:ml-0 group">
                            <div className="w-full">
                                {/* Title Updated */}
                                <h3 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-[15px]">
                                    Pioneering the Future of Finance
                                </h3>
                                {/* Description Updated */}
                                <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                    The Banking, Financial Services, and Insurance (BFSI) landscape requires absolute precision, ironclad security, and continuous innovation. At Mobikode, we deliver robust digital solutions that modernize legacy systems, ensure regulatory compliance, and create frictionless financial experiences for institutions and their customers alike.
                                </p>
                            </div>

                            {/* Animated Bottom Border */}
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cards Section Updated with BFSI Array */}
            <OurServiceOffer service={bfsiSolutions} />

            <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="Contact background" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section>
        </div>
    )
}

export default BFSIIndustryDetail